export const AppName = "InsureWise"